import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/sparkle.svg'
import _imports_1 from '@/assets/icons/star.svg'
import _imports_2 from '@/assets/icons/person_gray_150.png'
import _imports_3 from '@/assets/icons/connected_tree_arm.svg'
import _imports_4 from '@/assets/icons/connected_tree_base.svg'


const _withScopeId = n => (_pushScopeId("data-v-65bfef16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "doc-page compare-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Feature Comparison", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "page-intro" }, " Why choose Tree Crossing over other online trees? You might have a tree online somewhere, sure. But is it accomplishing everything you hoped? Does your family use it, learn from it, and love it? ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "page-intro" }, "See how Tree Crossing compares to other online trees in key areas:", -1))
const _hoisted_5 = { class: "compare-controls d-flex d-md-none align-items-center gap-3" }
const _hoisted_6 = {
  key: 0,
  class: "hint-text"
}
const _hoisted_7 = { class: "compare-wrapper" }
const _hoisted_8 = { class: "sticky-col-headers d-none d-md-grid" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sticky-prod-cell sticky-question-col" }, null, -1))
const _hoisted_10 = { class: "prod-name-line1" }
const _hoisted_11 = { class: "prod-name-line2" }
const _hoisted_12 = { class: "section-heading" }
const _hoisted_13 = {
  class: "section-icon",
  "aria-hidden": "true"
}
const _hoisted_14 = {
  key: 0,
  class: "icon-fun"
}
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_0 + "\" data-v-65bfef16><img src=\"" + _imports_0 + "\" data-v-65bfef16><img src=\"" + _imports_1 + "\" data-v-65bfef16><img src=\"" + _imports_1 + "\" data-v-65bfef16><img src=\"" + _imports_1 + "\" data-v-65bfef16>", 5)
const _hoisted_20 = [
  _hoisted_15
]
const _hoisted_21 = {
  key: 1,
  class: "icon-privacy"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "1944.17 850.17 512.67 514.67",
  preserveAspectRatio: "xMidYMid meet"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2200.5 868.5 2246.38 890.534C2292.58 910.017 2341.08 925.145 2391.36 935.403L2438.5 942.575 2438.5 1020.02C2438.5 1163.12 2351.23 1285.9 2226.86 1338.34L2200.5 1346.5 2174.14 1338.34C2049.77 1285.9 1962.5 1163.12 1962.5 1020.02L1962.5 942.575 2009.64 935.403C2059.92 925.145 2108.42 910.017 2154.62 890.534L2200.5 868.5Z",
    stroke: "#0070C0",
    "stroke-width": "36.6667",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-miterlimit": "10",
    fill: "none",
    "fill-rule": "evenodd"
  })
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "person"
}, null, -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  key: 2,
  class: "icon-connected"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tree-arm",
  src: _imports_3
}, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tree-arm",
  src: _imports_3
}, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tree-base",
  src: _imports_4
}, null, -1))
const _hoisted_29 = [
  _hoisted_26,
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = {
  key: 0,
  class: "section-subtitle"
}
const _hoisted_31 = { class: "questions-list" }
const _hoisted_32 = ["onClick", "aria-expanded", "onKeydown"]
const _hoisted_33 = { class: "matrix-question" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "matrix-chevron",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { class: "matrix-short" }
const _hoisted_37 = { class: "matrix-full" }
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = {
  key: 1,
  class: "answer-text"
}
const _hoisted_40 = { class: "d-md-none" }
const _hoisted_41 = ["onClick", "aria-expanded"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "chevron",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = {
  key: 0,
  class: "answer-panel no-anim"
}
const _hoisted_45 = { class: "answer-cells" }
const _hoisted_46 = { class: "mobile-prod-label" }
const _hoisted_47 = {
  key: 0,
  class: "tier-badge"
}
const _hoisted_48 = {
  class: "tier-icon",
  "aria-hidden": "true"
}
const _hoisted_49 = { class: "tier-label" }
const _hoisted_50 = ["innerHTML"]
const _hoisted_51 = {
  key: 2,
  class: "answer-text"
}
const _hoisted_52 = { class: "answer-cells" }
const _hoisted_53 = { class: "mobile-prod-label" }
const _hoisted_54 = {
  key: 0,
  class: "tier-badge"
}
const _hoisted_55 = {
  class: "tier-icon",
  "aria-hidden": "true"
}
const _hoisted_56 = { class: "tier-label" }
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = {
  key: 2,
  class: "answer-text"
}

import { ref, nextTick } from 'vue'
import { gsap } from 'gsap'
import { usePageTitle } from '@/util/AppUtil'
import { workspaceTypeInfos } from '@/rd/ResearchDataModel'

type Tier = 'limited' | 'partial' | 'best'

const showTierBadges = false

// ── App icon lookup ───────────────────────────────────────────────────────────

interface Answer {
  tier: Tier
  text?: string   // plain text — rendered as a <p>
  html?: string   // dev-authored markup — rendered via v-html; supports any structure
}

interface CompareQuestion {
  question: string       // may contain HTML markup
  shortAnswers: string[] // short text for the desktop matrix view (one per product)
  answers: Answer[]      // always 4, one per product in order
}

interface CompareSection {
  area: string
  subtitle?: string
  questions: CompareQuestion[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ComparePage',
  setup(__props) {

usePageTitle('Tree Crossing Feature Comparison')

// ── Product definitions ───────────────────────────────────────────────────────
// Edit SHORT names here — they appear as column headers throughout the page.

const products = [
  {
    name: 'Private Trees (Ancestry, TNG, etc.)',
    short: 'Private Trees',
    headerLines: ['Private Trees', '(Ancestry, TNG, etc.)'],
  },
  {
    name: 'Public Trees (FS Family Tree, etc.)',
    short: 'Public Trees (FS)',
    headerLines: ['Public Trees', '(FS Family Tree, etc.)'],
  },
  {
    name: 'FS User Trees (CET) – Controlled Edit',
    short: 'FS User Trees (CET)',
    headerLines: ['FS User Trees (CET)', 'Controlled Edit'],
  },
  {
    name: 'Tree Crossing – Connected Private',
    short: 'Tree Crossing',
    headerLines: ['Tree Crossing', 'Connected Private'],
  },
]

// ── Tier helpers ──────────────────────────────────────────────────────────────

function tierIcon(tier: Tier) {
  switch (tier) {
    case 'limited': return '✗'
    case 'partial': return '◑'
    case 'best':    return '✓'
  }
}

function tierLabel(tier: Tier) {
  switch (tier) {
    case 'limited': return ''
    case 'partial': return ''
    case 'best':    return ''
  }
}

// ── Page-level display controls ───────────────────────────────────────────────
// Toggle to show/hide the tier badges (✓ / ✗ / ◑) on all answer cells.

function appIcon(id: string): string | undefined {
  return workspaceTypeInfos.find(t => t.id === id)?.icon
}

// ── Comparison data ───────────────────────────────────────────────────────────

const sections: CompareSection[] = [
  {
    area: 'Sharing, learning and fun',
    questions: [
      {
        question: '<strong>Multiple trees in a single view.</strong><br />See your whole family as one, regardless of which trees or branches were contributed by various genealogists.',
        shortAnswers: [
          'No.',
          'No, not quite.',
          'No.',
          'Yes! This is the "crossing" in Tree Crossing.',
        ],
        answers: [
          { text: 'No.', tier: 'limited' },
          { html: "<p>No, not quite. It is a single view, but it is also a single tree which requires merging and is not comprised of multiple, independent trees.</p><p>It also may not contain the whole family for others, despite what you may think, or what may be the case just for you.</p><p>Your story is only part of their story.</p>", tier: 'partial' },
          { text: 'No.', tier: 'limited' },
          { html: '<p>Yes! This is the "crossing" in Tree Crossing.</p><p>All trees that have matches are connected (without merging) to be displayed as one complete tree, as it pertains uniquely to each family member.</p>', tier: 'best' },
        ],
      },
      {
        question: '<strong>The tree starts with you.</strong><br />Each family member starts from their own place in the tree (critical for relationship mapping and personal connection).',
        shortAnswers: [
          'Fixed start person.',
          'Starts with you.',
          'Fixed start person.',
          'Starts with you, no matter how many trees are connected.',
        ],
        answers: [
          { text: 'Fixed start person.', tier: 'partial' },
          { text: 'Starts with you.', tier: 'best' },
          { text: 'Fixed start person.', tier: 'partial' },
          { text: 'Starts with you, no matter how many trees are connected. ', tier: 'best' },
        ],
      },
      {
        question: '<strong>A fun learning experience.</strong><br />Accessing and exploring the tree is tailored for non-genealogist family members. Fun to explore and learn from.',
        shortAnswers: [
          'No. Genealogist-focused.',
          'No. Genealogist-focused.',
          'No. Very genealogist-focused.',
          'Yes. Specifically designed as a fun way for family to learn.',
        ],
        answers: [
          { text: 'No. These sites are generally very genealogist-focused, require user accounts that family members don\'t want to deal with, and have no parental controls.', tier: 'limited' },
          { text: 'No. These sites are generally genealogist-focused, require user accounts, have no parental controls, and are not ideal for living family to participate with each other.', tier: 'limited' },
          { text: 'No. This is very genealogist-focused and ideal mainly for very specific, focused collaboration with one or two extremely trusted people. Requires user accounts and has no parental controls.', tier: 'limited' },
          { html: '<p>Yes. Specifically designed as a fun way for family to learn.</p><p>The entire origin and purpose of Tree Crossing is to provide family members with a fun way to learn and explore, particularly those who are not genealogists.</p>', tier: 'best' },
        ],
      },
      {
        question: '<strong>Family interaction.</strong><br />Family members are able to interact with each other and share interesting highlights.',
        shortAnswers: [
          'No.',
          'To an extent. But is it the right experience?',
          'No.',
          'Planned - Coming soon. Tree is center of activity.',
        ],
        answers: [
          { text: 'No.', tier: 'limited' },
          { text: 'To an extent, but is it the right experience?', tier: 'partial' },
          { text: 'No.', tier: 'limited' },
          { html: '<p>Planned - Coming soon. Your tree becomes the center of activity.</p><p>Tree Crossing is adding intentional, tree-centric features to help family interact, find and share interesting things in the tree, ask questions of tree owners and other family members about ancestors or photos, and more.</p>', tier: 'partial' },
        ],
      },
      {
        question: '<strong>Explore highlights and points of interest.</strong><br />More than just names and dates; the tree provides interesting factoids, highlights, and new ways to view and explore the family tree.',
        shortAnswers: [
          'Not from within the tree.',
          'No.',
          'No.',
          'Yes, automatically from the data within the tree.',
        ],
        answers: [
          { text: 'Not from within the tree', tier: 'partial' },
          { text: 'No.', tier: 'limited' },
          { text: 'No.', tier: 'limited' },
          { html: '<p>Yes, automatically from the data within the tree.</p><p>Tree Crossing provides interesting factoids, highlights, and points of interest automatically from the data within the tree, and will continue to enhance this capability to make the learning experience as rich and engaging as possible, all done gracefully and without ever overwhelming the viewer.</p>', tier: 'best' },
        ],
      },
            {
        question: 'Can viewers see <strong>source information</strong>?',
        shortAnswers: [
          'Yes, but might be overwhelming.',
          'Yes, but might be overwhelming.',
          'Yes, but might be overwhelming.',
          'Planned - Coming soon.',
        ],
        answers: [
          { text: 'Yes, but might be overwhelming.', tier: 'best' },
          { text: 'Yes, but might be overwhelming.', tier: 'best' },
          { text: 'Yes, but might be overwhelming.', tier: 'best' },
          { text: 'Planned - Coming soon. And it will be easy to find as a natural part of the learning experience without overwhelming the viewer.', tier: 'partial' },
        ],
      },
    ],
  },
  {
    area: 'Privacy',
    questions: [
      {
        question: '<strong>Living people in the tree?</strong><br />Important for family members to be in the tree and see how they are connected, but without violating their privacy.',
        shortAnswers: [
          'Yes, without their consent.',
          'Yes, without their consent.',
          'Yes, without their consent.',
          'Yes, safely, with limited info, visible to family only.',
        ],
        answers: [
          { text: 'Yes, often with full personal details without their consent. Usually hidden from the public but visible to all who are invited.', tier: 'limited' },
          { text: 'Yes, often with full personal details without their consent. Hidden from the public by the service provider, but still there.', tier: 'limited' },
          { text: 'Yes, often with full personal details without their consent. Hidden from the public by the service provider, but fully visible to all editors.', tier: 'limited' },
          { html: '<p>Yes, but only names and relationships, visible only to specific groups.</p><p>Each person manages their own profile and decides what is visible. Personal, sensitive information is omitted, not uploaded.</p>', tier: 'best' },
        ],
      },
      {
        question: 'What information on living people is uploaded to the web?',
        shortAnswers: [
          'All of it, if it\'s in your GEDCOM or desktop program.',
          'All of it, if it\'s in your GEDCOM or desktop program.',
          'All of it, if it\'s in your GEDCOM or desktop program.',
          'Only names, relationships, and limited data. Nothing private.',
        ],
        answers: [
          { text: 'All of it, if it\'s in your GEDCOM or desktop program.', tier: 'limited' },
          { text: 'All of it, if it\'s in your GEDCOM or desktop program.', tier: 'limited' },
          { text: 'All of it, if it\'s in your GEDCOM or desktop program.', tier: 'limited' },
          { text: 'Only names, relationships, and limited data sufficient for the tree to work seamlessly to connect living people to their ancestors and each other. Nothing personal or private.', tier: 'best' },
        ],
      },
      {
        question: '<strong>Each person manages their own profile.</strong><br />Living people decide for themselves what is visible and to whom.',
        shortAnswers: ['No.', 'No.', 'No.', 'Yes.'],
        answers: [
          { text: 'No.', tier: 'limited' },
          { text: 'No. Even though you can add details to your own profile, other people can also make copies of you or anyone and add whatever they want. Not ideal.', tier: 'limited' },
          { text: 'No. If you are in a tree that someone uploaded, anyone added as a contributor, even if you do not know them, can see your details.', tier: 'limited' },
          { html: '<p>Yes, each person in the tree manages their own profile and decides for themselves what to make visible, and no copies, as it should be.</p><p>Other people cannot add any details to each others\' profiles, as that would not be appropriate. Genealogical details on living people may still exist in the genealogists own local database, and Tree Crossing does not affect that.</p>', tier: 'best' },
        ],
      },
      {
        question: '<strong>Parental controls.</strong><br />',
        shortAnswers: ['No.', 'No.', 'No.', 'Planned - Coming soon.'],
        answers: [
          { text: 'No.', tier: 'limited' },
          { text: 'No.', tier: 'limited' },
          { text: 'No.', tier: 'limited' },
          { text: 'Planned - Coming soon: parents will be able to create and manage child accounts', tier: 'partial' },
        ],
      },
    ],
  },
  {
    area: 'Collaboration',
    subtitle: 'Tree Crossing is not an online tree builder or research tool, however, due to the unique ability to connect trees without merging, an all-new take on collaboration becomes possible.',
    questions: [
      {
        question: '<strong>Ideal for multiple genealogists on the same tree.</strong><br />Is this good for multiple genealogists working on a common family name or ancestor?',
        shortAnswers: [
          'No. Editing is all-or-nothing, not ideal.',
          'No. Requires merging, high conflict. and contention.',
          'It depends. May be practical for very few, trusted contributors and circumstances.',
          'Yes. Work on your own part of the tree without affecting others.',
        ],
        answers: [
          { text: 'No. Trees are per-owner, and editing power is all-or-nothing, with no review/accept process.', tier: 'limited' },
          { text: 'No. It requires merging, the researcher loses fidelity of their work as a body of research, and the community can make negative changes. You can no longer perceive where your total research begins or ends within the tree.', tier: 'limited' },
          { html: '<p>It depends. Similar to some private trees: single owner, with optional editors.</p><p>This may only work effectively with a small number of very trusted researchers. It can get unwieldy for big projects with many contributors working on the same tree.</p><p>Additionally, the body of research of each person becomes conflated into a mixed environment.</p>', tier: 'partial' },
          { html: '<p>Yes. Work on any part of the tree without affecting others.</p><p>Researchers don\'t need to worry about sharing editing rights. Their work is published within their full control, and multiple researchers\' work (even on the same areas of the tree) is seamlessly connected where overlap exists.</p><p>Not only does nobody step on any toes, but ones own body of research and attribution is preserved.</p>', tier: 'best' },
        ],
      },
      {
        question: '<strong>Tree branch editing.</strong><br />Other editors are given permissions only on specific branches of a tree.',
        shortAnswers: [
          'No.',
          'No.',
          'No.',
          'Not applicable. Not a problem, due to connected trees.',
        ],
        answers: [
          { text: 'No.', tier: 'limited' },
          { text: 'No.', tier: 'limited' },
          { text: 'No. The workaround is to upload and maintain multiple separate trees, at which point none of them are connected for viewing or browsing.', tier: 'limited' },
          { html: '<p>Not applicable. Not a problem.</p><p>A "branch" is just a slice of the tree. You can put your slice in using the genealogy program you love, and it is automatically connected into a more complete tree where other relationships exist from other researchers, all without merging.</p>', tier: 'best' },
        ],
      },
      {
        question: '<strong>Genealogy program compatibility.</strong><br />What tree building software can directly sync with the website?',
        shortAnswers: [
          'Limited to none.',
          'Limited.',
          'Unannounced. Likely similar to FS Family Tree.',
          'Compatible with more programs than any other platform in the industry.',
        ],
        answers: [
          {
            tier: 'limited',
            html: `
              <p>Limited.</p>
              <p>For Ancestry:</p>
              <ul class="app-list">
                <li><img src="${appIcon('FamilyTreeMaker')}" class="app-icon" alt=""/> Family Tree Maker</li>
                <li><img src="${appIcon('RootsMagic')}" class="app-icon" alt=""/> RootsMagic</li>
              </ul>
              <br />
              <p>For MyHeritage:</p>
              <ul class="app-list">
                <li> - Family Tree Builder</li>
              </ul>
              <br />
              <p>For Findmypast, TNG, and others: </p>
              <p>None (no direct sync with genealogy programs. GEDCOM upload only)</p>
            `,
          },
          {
            tier: 'limited',
            html: `
              <p>Limited.</p>
              <p>For FamilySearch Family Tree:</p>
              <ul class="app-list">
                <li><img src="${appIcon('AncestralQuest')}" class="app-icon" alt=""/> Ancestral Quest</li>
                <li><img src="${appIcon('RootsMagic')}" class="app-icon" alt=""/> RootsMagic</li>
                <li><img src="${appIcon('Legacy')}" class="app-icon" alt=""/> Legacy Family Tree</li>
                <li> - Rootsfinder</li>
              </ul>
              <br />
              <p>For Wikitree:</p>
              <p>None (no direct sync with genealogy programs. GEDCOM upload only)</p>
            `,
          },
          {
            tier: 'partial',
            html: `
              <p>Unannounced, but the list won't likely be much different than the list for FS Family Tree.</p>
              <p>IMPORTANT: whichever you first upload with is the ONLY one you can use to sync (at the vendor's discretion), which is not good when multiple genealogists each use different programs.</p>
            `,
          },
          {
            tier: 'best',
            html: `
              <p><strong>Any</strong> of the following:</p>
              <ul class="app-list">
                <li><img src="${appIcon('FamilyTreeMaker')}" class="app-icon" alt=""/> Family Tree Maker</li>
                <li><img src="${appIcon('RootsMagic')}" class="app-icon" alt=""/> RootsMagic</li>
                <li><img src="${appIcon('AncestralQuest')}" class="app-icon" alt=""/> Ancestral Quest</li>
                <li><img src="${appIcon('Legacy')}" class="app-icon" alt=""/> Legacy Family Tree</li>
              </ul>
              <br />
              <p>Coming soon:</p>
              <ul class="app-list">
                <li><img src="${appIcon('Reunion')}" class="app-icon" alt=""/> Reunion</li>
                <li><img src="${appIcon('FamilyHistorian')}" class="app-icon" alt=""/> Family Historian</li>
                <li><img src="${appIcon('Gramps')}" class="app-icon" alt=""/> Gramps</li>
                <li> - FS Family Tree</li>
              </ul>
              <br />
              <p>More maybe be added in the future.</p>
              <p>Also, there is no issue with different researchers using different programs. Everyone keeps the program they love, and all tree data is automatically, seamlessly connected as one consolidated tree, no matter the origin.</p>
            `,
          },
        ],
      },
      {
        question: '<strong>Family contributions</strong>.<br />Contributions from non-genealogist family members, without needing edit access to the tree, who might have a photo or other valuable data.',
        shortAnswers: [
          'No.',
          'Sort of, but not ideal.',
          'No.',
          'Not yet. Coming soon!',
        ],
        answers: [
          { text: 'No.', tier: 'limited' },
          { text: 'Sort of, if you consider "Memories" to qualify. But arguably, this still counts as full edit access to the tree, and no way for genealogists to validate.', tier: 'partial' },
          { text: 'No. A contributor is all-or-nothing and can edit any aspect of the tree.', tier: 'limited' },
          { html: '<p>Not yet. Coming soon. Allow anyone in the family to submit things that the tree owner can then review, accept, and incorporate into their tree.</p><p>This is likely the most realistic type of collaboration, as most family members are not genealogists and not likely to help do deep research, but they do have a photo or document of "uncle Ned" to add to the collection.</p>', tier: 'partial' },
        ],
      },
      {
        question: '<strong>Tree visibility</strong>.<br />Tree owner decides what data is visible to others. Experimental trees, etc.',
        shortAnswers: [
          'Yes, public or private, nothing in between.',
          'No.',
          'No.',
          'Yes, with advanced control over visibility.',
        ],
        answers: [
          { text: 'Yes, public or private, nothing in between.', tier: 'partial' },
          { text: 'No. All data on deceased individuals is treated as public.', tier: 'limited' },
          { text: 'No. All data on deceased individuals is treated similar to the FS Family Tree (public).', tier: 'limited' },
          { html: '<p>Yes. The owner of a tree has full control over who can see it. Trees are not public by default.</p><p>Tree owners can select specific people or various groups of people to share with, and whether they can see specifically selected living people. Tree Crossing is also considering enabling limited public data fully at the owner\'s discretion and control.</p><p>It is not just all or nothing with Tree Crossing.</p>', tier: 'best' },
        ],
      },
      {
        question: '<strong>Third-party integrations</strong>.',
        shortAnswers: [
          'No. Platform lock-in.',
          'Limited and hidden.',
          'No, only genealogy programs.',
          'Yes! Integrations exist, and more to come.',
        ],
        answers: [
          { text: 'No. Most of these sites are very closed-off and platform-locked.', tier: 'limited' },
          { text: 'Limited and hidden. There are some, but they are buried, hard to find, and mostly focused on records and research-focused features with larger vendors.', tier: 'limited' },
          { text: 'No. Only the desktop genealogy programs are integrated for uploading and sync.', tier: 'limited' },
          { html: '<p>Yes! Tree Crossing integrates with Goldie May, a popular research tool, which means you can now use it on your own tree data without merging into the FamilySearch Family Tree.</p><p>Also, soon, many providers of additional services will be available. Tree Crossing believes very strongly that your data is your data, and is open to working with third parties rather than locking them out.</p>', tier: 'best' },
        ],
      },
       {
        question: 'Is <strong>GEDCOM upload</strong> supported?',
        shortAnswers: [
          'Yes.',
          'No.',
          'Yes, but once uploaded, you\'re locked in.',
          'Not yet, but coming soon. Also not needed — there\'s a better way.',
        ],
        answers: [
          { text: 'Yes.', tier: 'best' },
          { text: 'No.', tier: 'limited' },
          { text: 'Yes, but once uploaded, no genealogy program can be used to collaborate on that tree.', tier: 'partial' },
          { html: '<p>Not currently, and Tree Crossing views this as a good thing for active genealogists because GEDCOM prevents you from continuing to work in the program you love, and doesn\'t include photos and documents. Good for one-time publish, but not good for ongoing changes and sync.</p><p>A GEDCOM option is being considered for trees where no active research is being done.</p>', tier: 'best' },
        ],
      },
      {
        question: 'Is <strong>GEDCOM download</strong> supported?',
        shortAnswers: ['Yes.', 'No.', 'Unclear — apparently no.', 'Planned - Coming soon.'],
        answers: [
          { text: 'Yes.', tier: 'best' },
          { text: 'No.', tier: 'limited' },
          { text: 'Unclear — apparently not.', tier: 'limited' },
          { html: '<p>Planned - Coming soon.</p><p>GEDCOM download is being considered, and not only for your whole tree, but for portions of it. More information about this will be available soon.</p>', tier: 'partial' },
        ],
      },
    ],
  },
]

// ── Accordion state ───────────────────────────────────────────────────────────

const openKeys = ref(new Set<string>())
const expandedAll = ref(false)
const suppressAnim = ref(false)

function onEnterPanel(el: Element, done: () => void) {
  if (suppressAnim.value) { done(); return }
  const target = el as HTMLElement
  const naturalHeight = target.scrollHeight
  gsap.fromTo(target,
    { height: 0, opacity: 0, overflow: 'hidden' },
    { height: naturalHeight, opacity: 1, duration: 0.3, ease: 'power2.out', onComplete: () => {
      gsap.set(target, { clearProps: 'height,overflow' })
      done()
    }}
  )
}

function onLeavePanel(el: Element, done: () => void) {
  const target = el as HTMLElement
  gsap.to(target, {
    height: 0,
    opacity: 0,
    overflow: 'hidden',
    duration: 0.2,
    ease: 'power2.in',
    onComplete: done,
  })
}

function questionKey(area: string, qi: number) {
  return `${area}::${qi}`
}

function allKeys() {
  const keys = new Set<string>()
  for (const section of sections) {
    section.questions.forEach((_, qi) => keys.add(questionKey(section.area, qi)))
  }
  return keys
}

function isOpen(area: string, qi: number) {
  if (expandedAll.value) return true
  return openKeys.value.has(questionKey(area, qi))
}

// Keeps `el` from drifting above `minTop` viewport-px during layout shifts
// caused by collapsing content above it. Runs for `durationMs` via rAF.
function anchorScrollDuring(el: HTMLElement, minTop: number, durationMs: number) {
  const end = performance.now() + durationMs
  function frame() {
    if (performance.now() >= end) return
    const top = el.getBoundingClientRect().top
    if (top < minTop) window.scrollBy({ top: top - minTop, behavior: 'instant' })
    requestAnimationFrame(frame)
  }
  requestAnimationFrame(frame)
}

async function toggleQuestion(event: MouseEvent, area: string, qi: number) {
  const btn = event.currentTarget as HTMLElement
  const key = questionKey(area, qi)

  if (expandedAll.value) {
    if (window.innerWidth >= 768) {
      // Desktop: collapse just this item, keep all others open
      suppressAnim.value = true
      expandedAll.value = false
      const next = allKeys()
      next.delete(key)
      openKeys.value = next
      await nextTick()
      suppressAnim.value = false
    } else {
      // Mobile: exit expand-all with everything closed
      expandedAll.value = false
      openKeys.value = new Set()
    }
    return
  }

  const next = new Set(openKeys.value)

  if (window.innerWidth >= 768) {
    // Desktop: independent toggle — don't close other open items
    if (next.has(key)) next.delete(key)
    else next.add(key)
  } else {
    // Mobile: accordion — one open at a time
    const isOpening = !next.has(key)
    const hadOpenItem = next.size > 0
    if (next.has(key)) next.clear()
    else { next.clear(); next.add(key) }
    openKeys.value = next
    // If we opened a new item while another was open, anchor the button so it
    // doesn't scroll above the top of the viewport as the old item collapses.
    if (isOpening && hadOpenItem) anchorScrollDuring(btn, 20, 280)
    return
  }

  openKeys.value = next
}

// ── Desktop matrix row toggle ─────────────────────────────────────────────────
// GSAP controls all visibility — no v-if/v-show on matrix-short/matrix-full.
// Both elements are always in the DOM; CSS hides .matrix-full by default.

const _animatingRows = new Set<string>()

async function toggleDesktopRow(event: MouseEvent, area: string, qi: number) {
  const row = event.currentTarget as HTMLElement
  const key = questionKey(area, qi)
  if (_animatingRows.has(key)) return  // ignore clicks while animating
  _animatingRows.add(key)

  const isCurrentlyOpen = openKeys.value.has(key)
  const shorts = row.querySelectorAll<HTMLElement>('.matrix-short')
  const fulls  = row.querySelectorAll<HTMLElement>('.matrix-full')

  // Update logical state immediately so the chevron responds right away
  const next = new Set(openKeys.value)
  if (isCurrentlyOpen) next.delete(key)
  else next.add(key)
  openKeys.value = next

  if (!isCurrentlyOpen) {
    // ── Expanding ───────────────────────────────────────────────────────────
    const fromHeight = row.offsetHeight

    // Measure expanded height via an invisible synchronous swap (no repaint: no await in this block)
    gsap.set(shorts, { display: 'none' })
    gsap.set(fulls,  { display: 'block' })
    gsap.set(row,    { height: 'auto' })
    const toHeight = row.offsetHeight    // forces reflow; no repaint yet
    gsap.set(row,    { height: fromHeight, overflow: 'hidden' })
    gsap.set(fulls,  { display: 'none', opacity: 0 })
    gsap.set(shorts, { display: 'block', opacity: 1 })

    // Timeline — all phases overlap so text is never completely absent:
    //   t=0.00  shorts begin fading out
    //   t=0.08  height starts growing (shorts still ~55% visible)
    //   t=0.18  shorts fully gone → swap content → fulls start fading in
    //   t=0.38  height fully grown; fulls still fading in
    //   t=0.40  fulls fully visible → height override released
    await new Promise<void>(resolve => {
      gsap.timeline({ onComplete: resolve })
        .to(shorts, { opacity: 0, duration: 0.18, ease: 'power1.in' })
        .fromTo(row, { height: fromHeight }, { height: toHeight, duration: 0.38, ease: 'power3.out' }, 0.08)
        .call(() => {
          gsap.set(shorts, { display: 'none' })
          gsap.set(fulls,  { display: 'block', opacity: 0 })
        }, undefined, 0.18)
        .to(fulls, { opacity: 1, duration: 0.2, ease: 'power1.out' }, 0.20)
        .call(() => { gsap.set(row, { clearProps: 'height,overflow' }) })
    })

  } else {
    // ── Collapsing ──────────────────────────────────────────────────────────
    const fromHeight = row.offsetHeight

    // Measure collapsed height via invisible synchronous swap
    gsap.set(fulls,  { display: 'none' })
    gsap.set(shorts, { display: 'block' })
    gsap.set(row,    { height: 'auto' })
    const toHeight = row.offsetHeight    // forces reflow; no repaint yet
    gsap.set(row,    { height: fromHeight, overflow: 'hidden' })
    gsap.set(shorts, { display: 'none', opacity: 0 })
    gsap.set(fulls,  { display: 'block', opacity: 1 })

    // Timeline — reverse of expand:
    //   t=0.00  fulls begin fading out (+ slight upward drift)
    //   t=0.08  height starts shrinking (fulls still ~47% visible)
    //   t=0.15  fulls fully gone → swap content → shorts start fading in
    //   t=0.30  height fully shrunk; shorts still fading in
    //   t=0.32  shorts fully visible → height override released
    await new Promise<void>(resolve => {
      gsap.timeline({ onComplete: resolve })
        .to(fulls, { opacity: 0, y: -6, duration: 0.15, ease: 'power1.in' })
        .fromTo(row, { height: fromHeight }, { height: toHeight, duration: 0.26, ease: 'power2.in' }, 0.08)
        .call(() => {
          gsap.set(fulls,  { display: 'none', y: 0 })
          gsap.set(shorts, { display: 'block', opacity: 0 })
        }, undefined, 0.15)
        .to(shorts, { opacity: 1, duration: 0.15, ease: 'power1.out' }, 0.17)
        .call(() => { gsap.set(row, { clearProps: 'height,overflow' }) })
    })
  }

  _animatingRows.delete(key)
}

function toggleExpandAll() {
  if (expandedAll.value) {
    expandedAll.value = false
    openKeys.value = new Set()
  } else {
    openKeys.value = new Set()
    expandedAll.value = true
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "btn btn-sm btn-outline-secondary",
        onClick: toggleExpandAll
      }, _toDisplayString(expandedAll.value ? 'Collapse all' : 'Expand all'), 1),
      (!expandedAll.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Click any question to expand its answers"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(products, (prod, i) => {
          return _createElementVNode("div", {
            key: i,
            class: _normalizeClass(["sticky-prod-cell", `prod-col-${i}`])
          }, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(prod.headerLines[0]), 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(prod.headerLines[1]), 1)
          ], 2)
        }), 64))
      ]),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sections, (section) => {
        return _createElementVNode("div", {
          key: section.area,
          class: "compare-section"
        }, [
          _createElementVNode("h2", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, [
              (section.area.includes('learning'))
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _hoisted_20))
                : (section.area.includes('Privacy'))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _hoisted_24))
                  : (section.area.includes('Collaboration'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _hoisted_29))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createTextVNode("•")
                      ], 64))
            ]),
            _createTextVNode(" " + _toDisplayString(section.area), 1)
          ]),
          (section.subtitle)
            ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(section.subtitle), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_31, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.questions, (q, qi) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `${section.area}-${qi}`,
                class: _normalizeClass(["compare-item", { 'is-open': isOpen(section.area, qi) }])
              }, [
                _createElementVNode("div", {
                  class: "desktop-matrix-row d-none d-md-grid",
                  onClick: ($event: any) => (toggleDesktopRow($event, section.area, qi)),
                  role: "button",
                  tabindex: "0",
                  "aria-expanded": isOpen(section.area, qi),
                  onKeydown: [
                    _withKeys(_withModifiers(($event: any) => (toggleDesktopRow($event as unknown as MouseEvent, section.area, qi)), ["prevent"]), ["enter"]),
                    _withKeys(_withModifiers(($event: any) => (toggleDesktopRow($event as unknown as MouseEvent, section.area, qi)), ["prevent"]), ["space"])
                  ]
                }, [
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("span", {
                      class: "matrix-question-text",
                      innerHTML: q.question
                    }, null, 8, _hoisted_35)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(q.answers, (answer, ai) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: ai,
                      class: _normalizeClass(["matrix-answer", [`tier-${answer.tier}`, `prod-col-${ai}`]])
                    }, [
                      _createElementVNode("div", _hoisted_36, _toDisplayString(q.shortAnswers[ai]), 1),
                      _createElementVNode("div", _hoisted_37, [
                        (answer.html)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "answer-body",
                              innerHTML: answer.html
                            }, null, 8, _hoisted_38))
                          : (answer.text)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(answer.text), 1))
                            : _createCommentVNode("", true)
                      ])
                    ], 2))
                  }), 128))
                ], 40, _hoisted_32),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("button", {
                    class: "question-btn",
                    onClick: ($event: any) => (toggleQuestion($event, section.area, qi)),
                    "aria-expanded": isOpen(section.area, qi).toString()
                  }, [
                    _hoisted_42,
                    _createElementVNode("span", {
                      class: "question-text",
                      innerHTML: q.question
                    }, null, 8, _hoisted_43)
                  ], 8, _hoisted_41),
                  (expandedAll.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(q.answers, (answer, ai) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: ai,
                              class: _normalizeClass(["answer-cell", [`tier-${answer.tier}`, `prod-col-${ai}`]])
                            }, [
                              _createElementVNode("div", _hoisted_46, _toDisplayString(products[ai].short), 1),
                              showTierBadges
                                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                    _createElementVNode("span", _hoisted_48, _toDisplayString(tierIcon(answer.tier)), 1),
                                    _createElementVNode("span", _hoisted_49, _toDisplayString(tierLabel(answer.tier)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (answer.html)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "answer-body",
                                    innerHTML: answer.html
                                  }, null, 8, _hoisted_50))
                                : (answer.text)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(answer.text), 1))
                                  : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createBlock(_Transition, {
                        key: 1,
                        css: false,
                        onEnter: onEnterPanel,
                        onLeave: onLeavePanel
                      }, {
                        default: _withCtx(() => [
                          (isOpen(section.area, qi))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "answer-panel",
                                ref_for: true,
                                ref: "answerPanelRefs"
                              }, [
                                _createElementVNode("div", _hoisted_52, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(q.answers, (answer, ai) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: ai,
                                      class: _normalizeClass(["answer-cell", [`tier-${answer.tier}`, `prod-col-${ai}`]])
                                    }, [
                                      _createElementVNode("div", _hoisted_53, _toDisplayString(products[ai].short), 1),
                                      showTierBadges
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                            _createElementVNode("span", _hoisted_55, _toDisplayString(tierIcon(answer.tier)), 1),
                                            _createElementVNode("span", _hoisted_56, _toDisplayString(tierLabel(answer.tier)), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (answer.html)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            class: "answer-body",
                                            innerHTML: answer.html
                                          }, null, 8, _hoisted_57))
                                        : (answer.text)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_58, _toDisplayString(answer.text), 1))
                                          : _createCommentVNode("", true)
                                    ], 2))
                                  }), 128))
                                ])
                              ], 512))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                ])
              ], 2))
            }), 128))
          ])
        ])
      }), 64))
    ])
  ]))
}
}

})